import { render, staticRenderFns } from "./DownloadTooltip.vue?vue&type=template&id=4d37080d&"
import script from "./DownloadTooltip.vue?vue&type=script&lang=js&"
export * from "./DownloadTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports